var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcPersonalInfoWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.1866 28.8266C23.0132 29.1733 21.6266 29.3333 19.9999 29.3333H11.9999C10.3732 29.3333 8.98657 29.1733 7.81323 28.8266C8.10657 25.36 11.6666 22.6266 15.9999 22.6266C20.3332 22.6266 23.8932 25.36 24.1866 28.8266Z",
    stroke: "#F0F0F0",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0001 2.66666H12.0001C5.33341 2.66666 2.66675 5.33332 2.66675 12V20C2.66675 25.04 4.18675 27.8 7.81342 28.8267C8.10675 25.36 11.6667 22.6266 16.0001 22.6266C20.3334 22.6266 23.8934 25.36 24.1867 28.8267C27.8134 27.8 29.3334 25.04 29.3334 20V12C29.3334 5.33332 26.6667 2.66666 20.0001 2.66666ZM16.0001 18.8933C13.3601 18.8933 11.2267 16.7467 11.2267 14.1067C11.2267 11.4667 13.3601 9.33332 16.0001 9.33332C18.6401 9.33332 20.7734 11.4667 20.7734 14.1067C20.7734 16.7467 18.6401 18.8933 16.0001 18.8933Z",
    stroke: "#F0F0F0",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7732 14.1067C20.7732 16.7467 18.6399 18.8933 15.9999 18.8933C13.3599 18.8933 11.2266 16.7467 11.2266 14.1067C11.2266 11.4667 13.3599 9.33334 15.9999 9.33334C18.6399 9.33334 20.7732 11.4667 20.7732 14.1067Z",
    stroke: "#F0F0F0",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPersonalInfoWhite);
export default __webpack_public_path__ + "static/media/ic-personal-info-white.c6bc3c5bcab9bdcc93d46846acd4c012.svg";
export { ForwardRef as ReactComponent };